import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/newsroom/NewsDetails.jsx");
